/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface InventoryDeleteAuction$Params {
  id: string;
  inventoryId: string;
}

export function inventoryDeleteAuction(http: HttpClient, rootUrl: string, params: InventoryDeleteAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, inventoryDeleteAuction.PATH, 'delete');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

inventoryDeleteAuction.PATH = '/inventory/auctions';
